import { gql } from '@apollo/client';

export const GET_TV_APP_CONFIGURATION_BY_SLUG_QUERY = gql`
  fragment TvCommonStayInformationFields on StayInformation {
    id
    title
    content
    locale
    hidden
    appSortOrder
    bannerImage {
      id
      url
      formats
    }
    size
    externalBannerImage
  }

  fragment TvCommonSurroundingInformation on SurroundingInformation {
    id
    title
    appSortOrder
    bodyText
    externalBannerImage
    shortDescription
    bannerImage {
      id
      formats
      url
    }
    locale
  }

  query GetTvAppConfigurationBySlug($slug: String!) {
    tvAppConfigurations(where: { slug: $slug }) {
      id
      name
      order
      screens
      slug
      updated_at
      surroundingInformationCategories {
        id
        title
        locale
        localizations {
          id
          locale
          title
        }
        hidden
        surroundingInformations {
          ...TvCommonSurroundingInformation
          localizations {
            ...TvCommonSurroundingInformation
          }
        }
      }
      stayInformations {
        ...TvCommonStayInformationFields
        localizations {
          ...TvCommonStayInformationFields
        }
      }
    }
  }
`;
